// src/hooks/useAudio.js

import { useContext } from 'react';
import { AudioContext } from '../contexts/AudioContext';

export const useAudio = () => {
  const context = useContext(AudioContext);
  if (context === undefined) {
    throw new Error('useAudio doit être utilisé à l\'intérieur d\'un AudioProvider');
  }
  return context;
};